import bizNodeModel from '../../bizNodeModel.mjs'
import PsType from './PsType.jsx'

export default bizNodeModel({
    psName: {
        name: () => '程序结构标题',
    },

    psTypeCode: {
        name: () => '程序结构类型',

        readableValue: (map, node) => {
            const {psTypeCode} = node.data

            if (psTypeCode) {
                const match = PsType.find(e => psTypeCode === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },
    },

    psDesc: {
        name: () => '详述',
    },
})
